var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.finalNodeFlag
      ? _c("div", { staticClass: "mt5" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-mini mr10 fr",
              on: {
                click: function($event) {
                  _vm.refreshOaAuditRec()
                }
              }
            },
            [_vm._v("刷新")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.recList, border: "", "max-height": "400" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "nodeName",
                label: "审批环节",
                width: "200",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "auditorName",
                label: "审核人",
                width: "100",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "auditStatusStr",
                label: "审核状态",
                width: "100",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.nodeId != "提报"
                        ? _c("span", [
                            _c("span", [
                              _vm._v(_vm._s(rows.row.auditStatusStr || ""))
                            ])
                          ])
                        : _c("span", [_vm._v("已提报")])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "auditDesc", label: "审核描述", align: "left" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "finalNodeFlag",
                label: "是否终审",
                width: "80",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.finalNodeFlag
                        ? _c("span", [_vm._v("是")])
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "ts",
                label: "审核时间",
                width: "160",
                align: "center"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d8c9b45", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8c9b45","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/oaAudit/AuditBpRecsList.vue
// module id = 2544
// module chunks = 0